import styled from 'styled-components';

import { cardBoxShadow, respondDown } from 'styles/mixins';
import { Breakpoints, COLORS } from 'styles/style-constants';

export const SidebarBlock = styled.aside`
    top: 2rem;
    right: 10%;
    margin: -46rem 0 0;
    width: 36.6rem;
    background: ${COLORS.surface};
    border-radius: 0.5rem;
    position: sticky;
    float: right;
    ${cardBoxShadow};

    ${respondDown(Breakpoints.xl)`
        right: 4rem;
    `};

    ${respondDown(Breakpoints.md)`
        position: relative;
        width: calc(100% - 3.2rem);
        float: unset;
        top: unset;
        right: unset;
        margin: 1.6rem;
    `};
`;

export const Container = styled.div`
    padding: 3.2rem 4.8rem 4.8rem;

    a {
        text-decoration: none;
    }
`;

export const SidebarTitle = styled.h5`
    font-size: 2rem;
    line-height: 2.8rem;
    margin-bottom: 3.4rem;
    color: ${COLORS.textPrimary};
`;
